import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { HttpStatusCode } from '@serengeti/serengeti-common';
import { environment } from 'src/environments/environment';
import { EqualPasswordsValidator } from '../validator/equal-passwords-validator';
import {EmailValidator} from '../validator/email-validator';
import {GuestUserService} from "@serengeti/serengeti-user";


@Component({
  selector: 'app-member-change-password',
  templateUrl: './change.password.component.html',
  styleUrls: ['./change.password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  public form: FormGroup;
  public userId: AbstractControl;
  public email: AbstractControl;
  public password:AbstractControl;
  public repeatPassword:AbstractControl;
  public passwords: FormGroup;
  public locale: AbstractControl;

  public loading:boolean = false;

  profile = environment.profile;

  routeSubscription: Subscription;

  mode: string = "change-password-request";

  constructor(
    formBuilder: FormBuilder,
    private guestUserService: GuestUserService,
    private translateService: TranslateService,
    private router: Router,
  ) {

    this.form = formBuilder.group({
      'userId': ['', Validators.compose([Validators.required, Validators.minLength(8)])],
      'email': ['', Validators.compose([Validators.required, EmailValidator.validate])],
      'passwords': formBuilder.group({
        'password': ['', Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,}$/)])],
        'repeatPassword': ['', Validators.compose([Validators.required, Validators.minLength(8)])]
      }, {validator: EqualPasswordsValidator.validate('password', 'repeatPassword')})
    });

    this.userId = this.form.controls['userId'];
    this.email = this.form.controls['email'];
    this.passwords = <FormGroup> this.form.controls['passwords'];
    this.password = this.passwords.controls['password'];
    this.repeatPassword = this.passwords.controls['repeatPassword'];

    this.routeSubscription = this.router.events.subscribe((event: NavigationEnd) => {
      if (event instanceof NavigationEnd) {

        const url = this.router.parseUrl(event.url);

        if(url.root.children['primary'] && url.root.children['primary'].segments[0].path=='change-password') {

          const id = url.queryParams['userId'];
          const key = url.queryParams['authKey'];

          if(id && key) {

            this.translateService.get(['home.change-password.alert.invalid-password-key']).subscribe(messages=>{
              this.guestUserService.check_password_key(id, key).subscribe(result=>{
                if(result) {
                  this.userId.setValue(id);
                  this.mode = "change-password-form";
                  this.form.controls['email'].clearValidators();
                  this.form.controls['email'].updateValueAndValidity();
                }
                else {
                  alert(messages['home.change-password.alert.invalid-password-key']);
                  this.router.navigate(['/member/login']);
                }
              });
            });
          }
          else {
            this.passwords.controls['password'].clearValidators();
            this.passwords.controls['password'].updateValueAndValidity();
            this.passwords.controls['repeatPassword'].clearValidators();
            this.passwords.controls['repeatPassword'].updateValueAndValidity();
          }
      }
    }});
  }

  ngOnInit() {

  }


  public onSubmit(values:any):void {

    const user = {
      userId : values.userId,
      email: values.email,
      userName : values.name,
      password: values.passwords.password,
    };

    this.loading = true;

    if (this.form.valid) {

      this.translateService.get([
        'home.change-password.title',
        'home.change-password.alert.user-not-found',
        'home.change-password.alert.change-password-successed',
        'home.change-password.alert.change-password-request-successed',
        'home.change-password.confirm.change'
      ]).subscribe((messages: any) => {

        if(this.mode=='change-password-request') {
          this.guestUserService.change_password_request(this.userId.value, this.email.value).subscribe(
            user => {
              alert(messages['home.change-password.alert.change-password-request-successed'])
              this.loading = false;
            },
            error => {
              this.loading = false;
              switch (error.status) {
                case HttpStatusCode.NOT_FOUND:
                default:
                  alert(messages['home.change-password.alert.user-not-found'])
                  break;
              }

            }
          );

        }
        else {
          if (confirm(messages['home.change-password.confirm.change'])) {
            this.guestUserService.change_password(user.userId, user).subscribe(result=>{
              alert(messages['home.change-password.alert.change-password-successed'])
              this.router.navigate(['/member/login']);
            });
          }
          else {
            this.loading = false;
          }
        }
      });
    }
  }
}
